import { ExperienceSkill } from 'src/typings/api-models.generated';
import { Icon } from 'src/ui/shared/components/icon/Icon';

interface Props {
    experienceSkill: ExperienceSkill;
}

export const ExperienceSkillRankDisplay = ({ experienceSkill: { rank } }: Props) => {
    let number = 0;
    switch (rank) {
        case 'fiveStar': {
            number = 5;
            break;
        }
        case 'fourStar': {
            number = 4;
            break;
        }
        case 'threeStar': {
            number = 3;
            break;
        }
        case 'twoStar': {
            number = 2;
            break;
        }
        case 'oneStar': {
            number = 1;
            break;
        }
    }

    if (number === 0) {
        return <small>({rank})</small>;
    }

    return (
        <span className="text-nowrap">
            {Array.from({ length: 5 }).map((_, index) => {
                return (
                    <Icon
                        key={index}
                        icon="star-fill"
                        iconStyles={{ color: index < number ? 'gold' : 'grey' }}
                    />
                );
            })}
        </span>
    );
};
